<template>
  <div class="full-bar">
    <div class="bar-new-1 horizontal layout">
      <div class="bar-new-3" id="progress-bar-3" />
      <div class="flex">
        <div class="bar-new-2" id="progress-bar-line" />
      </div>
    </div>
  </div>
</template>
<script>
import EvenBus from '@/eventBus'
import storage from '@/services/storage'
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    EvenBus.$on('show-full-progess-bar-quiz', () => {
      const elmProgessBar = document.getElementById('progress-bar-line')
      elmProgessBar.style['animation-duration'] = '0s'
    })
    EvenBus.$on('restart-progess-bar-quiz', () => {
      this._runProgessBar()
    })
    EvenBus.$on('stop-progess-bar-quiz', () => {
      const elmProgessBar = document.getElementById('progress-bar-line')
      elmProgessBar.style['animation-play-state'] = 'paused'
    })
    this._runProgessBar()
  },
  destroyed() {
    EvenBus.$off('restart-progess-bar-quiz')
    EvenBus.$off('stop-progess-bar-quiz')
    EvenBus.$off('show-full-progess-bar-quiz')
  },
  methods: {
    _runProgessBar() {
      if (this.presentation.audiencePacing) {
        const answeredSlideIds = storage.getValueByPresentation(this.presentation.id, 'answeredSlideIds', [])
        if (answeredSlideIds.includes(this.slide.id)) {
          return
        }
      }
      const startTime = new Date().getTime() + this.$store.state.countdownTimeToAnswer * 1000
      const countTimeToAnswer = parseInt((startTime - new Date().getTime()) / 1000, 10)
      const countToAnswer = parseInt(((this.$store.state.slide.timeToAnswer - countTimeToAnswer) / this.$store.state.slide.timeToAnswer) * 100, 10)
      const elmProgessBar = document.getElementById('progress-bar-line')
      const elmProgessBarDefault = document.getElementById('progress-bar-3')
      if (elmProgessBarDefault) {
        elmProgessBarDefault.style.width = `${countToAnswer}%`
      }
      if (elmProgessBar) {
        if (countTimeToAnswer > 0) {
          elmProgessBar.style.animationDuration = `${countTimeToAnswer}s`
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.full-bar {
  background-color: #f1f1f1;
  border: 1px solid #fff;
}

.bar-new-1 {
  background: #f1f1f1;
  height: 12px;
}

.bar-new-2 {
  animation-name: progress-bar;
  animation-timing-function: linear;
  background: $primary-color;
  box-sizing: border-box;
  height: 100%;
}

#progress-bar-3 {
  height: 12px;
  background-color: $primary-color;
  width: 0;
}

@keyframes progress-bar {
  from {width: 0%;}
  to {width: 100%;}
}
</style>
